import { createAxios } from 'ts/createAxios';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import { CommonType } from 'util/Types';

export const getTemporaryStorages = async (params?: {
  successCallback?: (data: CommonType[]) => void;
}) => {
  const { successCallback } = params ?? {};

  try {
    const { data } = await createAxios().get<CommonType[]>(
      API_ENDPOINTS.EMISSION_TEMPORARY_STORAGES
    );

    if (data) {
      successCallback?.(data);
    }
  } catch (error) {
    handleError(error);
  }
};
